import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

import routing from "../../../../routing";
import { StaffLines } from "../../../../components/Nav/StaffLines";
import Icons from "../../../../icons";
import Icon from "../../../../icon";
import { useUser } from "../../../../store/user/selectors";

import {
    StyledNavLeft,
    MenuItem,
    Logo,
    StyledStaffLinesLeft,
} from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const NavLeft = ({ isPathDashboard }: IProps) => {
    const { formatMessage, locale } = useIntl();
    const { loggedIn, profiled } = useUser();
    return (
        <StyledNavLeft>
            <Logo>
                <Link to={`/${routing.choir}`}>
                    <StyledStaffLinesLeft>
                        <StaffLines />
                    </StyledStaffLinesLeft>
                    <Icons.Logo slogen={formatMessage(messages.slogen)} locale={locale} />
                </Link>
            </Logo>
            {loggedIn && profiled && (
                <MenuItem $isActive={isPathDashboard} to={`/${routing.choir}/${routing.dashboard}`}>
                    <Icon i="dashboard" />
                    <FormattedMessage {...messages.dashboard} />
                </MenuItem>
            )}
        </StyledNavLeft>
    );
}

export default NavLeft;
